export function getTranslation(value) {
    const lang = document.querySelector('html').getAttribute('lang');
    const translations = {
        es: {
            'No results found for': 'No se encontraron resultados para',
        },
    };
    return translations[lang][value.toString()] || value;
}
